import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import DarkIcon from '@material-ui/icons/Brightness2';
import LightIcon from '@material-ui/icons/WbSunny';
import { fnDarkTheme, fnLightTheme } from '../../theme/fnThemes';

/*
 * Both variants are registered so the user-settings theme picker keeps its
 * "Auto" option, which follows the OS colour scheme. The built-in Backstage
 * themes are switched off in app-config.yaml, leaving these two as the only
 * choices.
 */

const fnLightThemeExtension = ThemeBlueprint.make({
  name: 'fn-light',
  params: {
    theme: {
      id: 'fn-light',
      title: 'Fressnapf Light',
      variant: 'light',
      icon: <LightIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={fnLightTheme} children={children} />
      ),
    },
  },
});

const fnDarkThemeExtension = ThemeBlueprint.make({
  name: 'fn-dark',
  params: {
    theme: {
      id: 'fn-dark',
      title: 'Fressnapf Dark',
      variant: 'dark',
      icon: <DarkIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={fnDarkTheme} children={children} />
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [fnLightThemeExtension, fnDarkThemeExtension],
});
